export const testimonials = [
  {
    id: 1,
    quote: "I came in feeling completely lost. After just a few sessions, I had language for what I was feeling and a real path forward. Clarity Point changed my life.",
    name: "Sarah M.",
    descriptor: "Anxiety & Life Transitions Client",
    image: "/images/t1.jpg",
  },
  {
    id: 2,
    quote: "I was skeptical about therapy, but the warmth and non-judgmental approach here made all the difference. I finally feel like myself again.",
    name: "James R.",
    descriptor: "Stress Management Client",
    image: "/images/t4.jpg",
  },
  {
    id: 3,
    quote: "Going through a major life change felt impossible alone. Having a safe space to process everything made the transition so much more manageable.",
    name: "Elena T.",
    descriptor: "Relationship Support Client",
    image: "/images/t5.jpg",
  },
];

export const faqs = [
  {
    question: "Do you accept insurance?",
    answer: "We are currently an out-of-network provider. We can provide a superbill for you to submit to your insurance for potential reimbursement. Many clients find their out-of-network benefits cover a significant portion of session costs.",
  },
  {
    question: "How long are sessions?",
    answer: "Individual therapy sessions are 50 minutes. Initial consultations are 20 minutes and are complimentary — a chance for us to connect and see if we're a good fit.",
  },
  {
    question: "What can I expect in the first session?",
    answer: "The first session is about getting to know you — your story, what's brought you here, and what you're hoping to work toward. There's no pressure to share more than you're comfortable with. We go at your pace.",
  },
  {
    question: "Do you offer virtual sessions?",
    answer: "Yes! We offer both in-person and secure video sessions, so you can choose what feels most comfortable and convenient for you.",
  },
  {
    question: "How often will we meet?",
    answer: "Most clients begin with weekly sessions to build momentum and consistency. As you progress, we can adjust the frequency together based on your needs and goals.",
  },
];